import PropTypes from "prop-types";
import { useCallback, useEffect, useState } from "react";
import API from "../services/api-request";
import { Row, Select, Spin } from "antd";
import { capitalizeLetter } from "../utils/capitalizeLetter";

const mergeUniqueById = (prevData, newData) => {
  const existingIds = new Set(prevData.map((item) => item.id));
  return [
    ...prevData,
    ...newData.filter((item) => !existingIds.has(item.id)),
  ];
};

const SelectMaterialHandling = ({ value, onChange, disabled }) => {
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getMaterialHandling = useCallback(async () => {
    setLoading(true);
    try {
      const res = await API.Get("material-handling");
      const newData = res?.data || [];
      setListData((prevData) => mergeUniqueById(prevData, newData));
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getMaterialHandling();
  }, [getMaterialHandling]);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear={false}
      disabled={disabled}
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder="Pilih Material Handling"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: capitalizeLetter(e.type),
        value: e.type,
        cost: e.cost,
      }))}
    />
  );
};


SelectMaterialHandling.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SelectMaterialHandling;
